// client/src/components/account/AccountSettings.js - VERSÃO CORRIGIDA
import React, { useEffect } from 'react';
import { useMe } from '../../hooks/useAuth';
import ContaSettingsPanel from '../plataforma/contas/ContaSettingsPanel';
import { Loader2, Globe, ArrowLeft, AlertCircle } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import useAlert from '../../hooks/useAlert';

const AccountSettings = () => {
    const { user, isLoading, error, getAccountId, hasAccount } = useMe();
    const { setAlert } = useAlert();
    const navigate = useNavigate();
    
    const accountId = getAccountId();

    // ✅ CORREÇÃO: Monitorar erros de conta
    useEffect(() => {
        if (error && !isLoading) {
            console.error('❌ [AccountSettings] Erro ao carregar conta:', error);
            setAlert(error.message || 'Erro ao carregar dados da conta', 'danger');
        }
    }, [error, isLoading, setAlert]);

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-64">
                <Loader2 className="animate-spin text-indigo-600" size={40} />
                <span className="ml-3 text-gray-600">Carregando sua conta...</span>
            </div>
        );
    }

    // ✅ CORREÇÃO: Tratamento de erro mais robusto
    if (error || !hasAccount()) {
        return (
            <div className="p-8 max-w-2xl mx-auto">
                <div className="alert alert-danger">
                    <AlertCircle className="icon" />
                    <div>
                        <h3 className="font-semibold">Conta não encontrada</h3>
                        <p className="text-sm mt-1">
                            {error?.message || 'Nenhuma conta associada ao seu usuário.'}
                        </p>
                        <div className="flex gap-3 mt-4">
                            <button 
                                onClick={() => window.location.reload()}
                                className="action-button action-button-secondary"
                            >
                                Tentar Novamente
                            </button>
                            <Link 
                                to="/"
                                className="action-button action-button-primary"
                            >
                                <ArrowLeft size={16} className="icon" />
                                Voltar ao Dashboard
                            </Link>
                        </div>
                    </div>
                </div>
                
                {/* ✅ DEBUG INFO para desenvolvimento */}
                {process.env.NODE_ENV === 'development' && (
                    <div className="mt-6 p-4 bg-gray-100 rounded border">
                        <h4 className="font-medium text-gray-900 mb-2">Informações de Debug:</h4>
                        <pre className="text-xs text-gray-700">
                            {JSON.stringify({
                                hasUser: !!user,
                                userId: user?._id,
                                userEmail: user?.email,
                                hasAccount: hasAccount(),
                                accountId,
                                accountsCount: user?.accounts?.length,
                                accounts: user?.accounts?.map(acc => ({
                                    id: acc._id,
                                    accountId: acc.account?._id,
                                    accountName: acc.account?.name,
                                    status: acc.status
                                })),
                                error: error?.message
                            }, null, 2)}
                        </pre>
                    </div>
                )}
            </div>
        );
    }

    console.log('✅ [AccountSettings] Renderizando com conta:', {
        accountId,
        accountName: user?.account?.name,
        userId: user?._id
    });

    return (
        <div className="page-management-container">
            <div className="page-header">
                <div className="flex items-center gap-4">
                    <Link 
                        to="/"
                        className="action-button action-button-secondary"
                    >
                        <ArrowLeft size={16} className="icon" />
                        Voltar ao Dashboard
                    </Link>
                    <h1 className="page-title">
                        <Globe className="icon-title" />
                        Configurações da Conta
                    </h1>
                </div>
                
                <div className="actions-bar">
                    <Link 
                        to="/minha-conta/pagina-publica"
                        className="action-button action-button-primary"
                    >
                        <Globe size={18} className="icon" />
                        Configurar Página Pública
                    </Link>
                </div>
            </div>

            {/* ✅ CORREÇÃO: Garantir que accountId existe antes de renderizar */}
            <ContaSettingsPanel 
                accountId={accountId} 
                isMyAccount={true} 
                key={accountId} // ✅ Forçar re-render quando accountId mudar
            />
        </div>
    );
};

export default AccountSettings;